// ===========================================
// SMS & WhatsApp Settings Page
// ===========================================
// Admin page for customizing SMS/WhatsApp message templates

import { Alert, Box } from '@mui/material';
import { usePermissions } from '../../hooks/usePermissions';
import PageHeader from '../../components/common/PageHeader';
import SmsTemplateManagerCard from '../../components/admin/settings/SmsTemplateManagerCard';

export default function SmsSettingsPage() {
  const { can } = usePermissions();
  const canWrite = can('communications_settings', 'write');

  return (
    <Box>
      <PageHeader
        title="SMS & WhatsApp Settings"
        subtitle="Customize the system SMS and WhatsApp messages sent to parents and students. Both channels share the same message template."
        breadcrumbs={[
          { label: 'Admin', path: '/admin' },
          { label: 'Communications' },
          { label: 'SMS & WhatsApp Settings' },
        ]}
      />
      {!canWrite && (
        <Alert severity="info" sx={{ mb: 2 }}>
          You can view these settings. Changing them needs the Communications Settings permission.
        </Alert>
      )}
      <SmsTemplateManagerCard readOnly={!canWrite} />
    </Box>
  );
}
